// @flow

import _ from 'lodash';

export default class ApiError {

  code: number;
  message: string;
  detail: string;
  extra: object;

  /*
   * Generate on the api request when an error occured.
   * User /utils/apiErrors utils to get the localizedMessage.
   */
  localizedMessage: string;
  sessionId: string;
  statusCode: ?number;
  oauthError: ?string;

  constructor(code: number = 0, message: string = '', detail: string = '',
      sessionId: string = '') {
    this.code = code;
    this.message = message;
    this.detail = detail;
    this.sessionId = sessionId;
  }

  getCode(): number {
    return this.code;
  }

  getMessage(): string {
    return this.message;
  }

  setCode(code: number) {
    this.code = code;
  }

  setMessage(message: string) {
    this.message = message;
  }

  setExtra(extra: object) {
    this.extra = extra;
  }

  setDetail(detail: string) {
    this.detail = detail;
  }

  getDetail(): string {
    if (_.isEmpty(this.detail) || _.isNull(this.detail)) {
      console.error('Unknown api error', this.code, this.message);
      // TODO: localized
      return 'Erreur inconnue';
    }
    return this.detail;
  }

  getSessionId(): string {
    return this.sessionId;
  }

  setSessionId(sessionId: string) {
    this.sessionId = sessionId;
  }

}
